import { render, staticRenderFns } from "./App.vue?vue&type=template&id=b1123a3c&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=b1123a3c&prod&lang=css"
import style1 from "./App.vue?vue&type=style&index=1&id=b1123a3c&prod&scoped=true&lang=css"
import style2 from "./App.vue?vue&type=style&index=2&id=b1123a3c&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1123a3c",
  null
  
)

export default component.exports